// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { CtsGantryInitEvent } from '../../interfaces/cts-gantry-init-event';
import { CtsGantryInitEventStatusService } from '../../services/cts-gantry-init-event-status.service';
import { CtsGantryTimeZoneService } from '../../services/cts-gantry-time-zone.service';
import { toSignal } from '@angular/core/rxjs-interop';
import moment from 'moment';

@Component({
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-cts-gantry-init-event',
  templateUrl: './cts-gantry-init-event.component.html',
  styleUrl: './cts-gantry-init-event.component.scss',
})
export class CtsGantryInitEventComponent {
  gantryEvent = input.required<CtsGantryInitEvent>();
  reducedLabel = input<boolean>(false);

  timeZone = toSignal(this.timeZoneService.timeZone());
  timestamp = computed(() => {
    const gEvent = this.gantryEvent();
    const tz = this.timeZone();
    const result = moment(gEvent.timestamp).utcOffset(
      tz ? tz.offsetInMinutes : gEvent.timestampOffset / 60,
    );

    return result;
  });

  dayMonth = computed(() => this.timestamp().format('DD MMM'));
  hourMinute = computed(() => this.timestamp().format('HH:mm'));

  public constructor(
    protected readonly timeZoneService: CtsGantryTimeZoneService,
    protected readonly ctsGantryInitEventStatusService: CtsGantryInitEventStatusService,
  ) {}
}
